// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root__3xTGy","slogan":"Home_slogan__tfBYg"};